import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import ReduxThunk from 'redux-thunk';

import reducer from './reducers';

export const store = createStore(reducer, {}, composeWithDevTools(applyMiddleware(ReduxThunk)));
